module.exports = __webpack_public_path__ + "img/social-network-map@2x.64980c40.png";